import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import {  convertToLowestUnit, ExportAvailableInCSVForReports, exportFromula, formatUnitsForReport , GetUpdatedDelivered, mapUnits } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";

const BranchwiseProductBalanceInventoriesReport = (props) => {
 

  const { SearchBar } = Search;
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState();
  const [grandTotal, setGrandTotal] = useState(0);
      const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
      const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [isLoadingBranchDetails, setIsLoadingBranchDetails] = useState(false);
  const [isLoadingProductDetails, setIsLoadingProductDetails] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const searchSigRef = useRef("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const storeId = params.get('store_id');
    if (storeId) {
      loadDataWithParams(storeId);
    } else {
      loadOrders();
    }
  }, []);

  const [filterModalTotal, setFilterModalTotal] = useState(0);

  function afterFilter(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0
    );
    setFilterModalTotal(total.toFixed(2));
  }
function afterSearch(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.product_cost),
      0
    );
    const sig = `${newResult.length}:${Number(total.toFixed(2))}`;
    setFilteredOrders((prevOrders) => {
      if (searchSigRef.current === sig) return prevOrders;
      searchSigRef.current = sig;
      return newResult;
    });

    setGrandTotal(Number(total.toFixed(2)));
  }
  const [allOrders, setAllOrders] = useState([]);
  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
    setIsLoadingOrders(true);

    let url = process.env.REACT_APP_BASEURL + "reports/branchwise_balance_products";
    const response = await postSubmitForm(url, {
    });

    if (requestId !== ordersRequestId.current) return null;
    if (response && response.status === 1) {
      setGrandTotal(response.data.grand_total_cost);
      setAllOrders(response.data.branches || []);
      setTablePage(1);
      return response.data.branches;
    } else {
      showNotification(response && response.message, "Error");
      return null;
    }
    } catch (error) {
     if (requestId !== ordersRequestId.current) return null;
     console.log(error);
     return null;
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const loadDataWithParams = async (storeId) => {
    const orders = await loadOrders(); 
    
    if (orders && storeId) {
      const selectedStore = orders.find(store => String(store._id) === String(storeId));
      if (selectedStore) {
        setSelectedBranch(selectedStore);
        await loadBranchwiseProductsDetails(selectedStore);
      }
    }
  };

  const loadBranchwiseProductsDetails = async (row) => {
  try {
    setSelectedBranch(row);
    setSelectedRow([]);
    setProductModal(true);
    setIsLoadingBranchDetails(true);
    let url = process.env.REACT_APP_BASEURL + "reports/branchwise_balance_products_details";
    const response = await postSubmitForm(url, {branch_id: row._id});
    if (response && response.status === 1) {
      setSelectedRow(response.data.products || []);
      setFilterModalTotal(response.data.grand_total_cost);
    } else {
      showNotification(response && response.message, "Error");
    }
  } catch (error) {
    console.log(error);
  } finally {
    setIsLoadingBranchDetails(false);
  }
  };

    
      const [productDetailsModal, setProductDetailsModal] = useState(false);
      const [productDetails, setProductDetails] = useState([]);
  const loadProductDetails = async (product_id) => {
    try {
      setIsLoadingProductDetails(true);
      setProductDetails([]);
      setProductDetailsModal(true);
  
      let url = process.env.REACT_APP_BASEURL + "reports/branchwise_balance_products_by_product";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        product_id: product_id,
      });
      if (response && response.status === 1) {
               const data = response.data || [];
              let totalReceivingCost = 0;
              let totalLowestUnitQty = 0;  
              
              data.forEach(item => {
                const { 
                  receiving_cost = 0,
                  unit_levels,
                  quantity
                } = item || {};
        
                totalReceivingCost += Number(receiving_cost);
        
                if (unit_levels && quantity) {
                  const convertedQty = convertToLowestUnit(unit_levels, quantity);
                  totalLowestUnitQty += Number(convertedQty || 0);
                }
              });
        
              let displayQuantity = "";
              const firstDeliveryDetails = data[0]
              if (firstDeliveryDetails?.unit_levels) {
                const { unit_levels } = firstDeliveryDetails;
                const lowestUnit = unit_levels.at(-1).unit;
                
                const summedQuantity = [{
                  unit: lowestUnit,
                  value: totalLowestUnitQty
                }];
                
                displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
              }
        setProductDetails(data);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingProductDetails(false);
    }
  };
  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (allOrders.length > 0) {
      if (orderStatus === "All") {
        setFilteredOrders([...allOrders]);
      } else {
        let arr = allOrders.filter((order) => order.status === orderStatus);
        setFilteredOrders(arr);
      }
    }
  }, [allOrders, orderStatus]);

  const [productModal, setProductModal] = useState(false);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "product_cost",
      text: props.t("Product Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadBranchwiseProductsDetails(row);
            }}
          >
            {row.product_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
  ];

  const columnsProduct = [
    {
      dataField: "product_id",
      hidden: true,
    },
    {
      dataField: "product_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadProductDetails(row.product_id);
            }}
          >
            {row.name}
            </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "19%" };
      },
    },
    // {
    //   text: props.t("Section"),
    //   dataField: "section",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ section: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },

    // {
    //   dataField: "price",
    //   text: props.t("Price (QR)"),

    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },
    {
      dataField: "quantity",
      text: props.t("Total Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Costing Unit"),
      dataField: "unit_for_cost_price",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "use_date",
    //   text: props.t("Date"),
    //   formatter: (cell, row) => {
    //     return moment(row.use_date).format("DD/MM/YYYY HH:mm");
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },
  ];

 const columnsProductDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "unit_for_cost_price",
      text: props.t("Costing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "price",
      text: props.t("Price (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
    {
      dataField: "receiving_cost",
      text: props.t("Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "created_at",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.created_at).format(
          "DD/MM/YYYY HH:mm"
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
  ];


  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "branchwise_product_balance_report_";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          ProductCost: v.product_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleDownloadModalData = async () => {
    const fileName = "branchwise_Used_prodct_detail_report_" ;
    const exportType = "xls";

    let data_to_export = selectedRow && selectedRow;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Product: v.name,
          Formula: v.unit_levels && exportFromula(v.unit_levels),
          "Total Quantity":ExportAvailableInCSVForReports(v.quantity),
          "Costing Unit": v.unit_for_cost_price,
          "Total Cost": v.receiving_cost,
        });
      });
      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t(
              "Branchwise Balance Finished Product Report"
            )}
            title={props.t("Reports")}
            breadcrumbItem={props.t(
              "Branchwise Balance Finished Product Report"
            )}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Branchwise Balance Finished Product Report")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={filteredOrders && filteredOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                                  delay={500}
                                 onSearch={(searchText) => {      
                                  if (!searchText || searchText.trim() === '') {
                                toolkitProps.searchProps.onSearch(searchText);
                                afterSearch(toolkitProps.baseProps.data); 
                                return
                                  }
                                  if(searchText?.length <= 3) 
                                    return                      
                                  const searchResult = toolkitProps.baseProps.data?.filter(row => {
                                  const matchesSearch = (value) => {
                                    if (value === null || value === undefined) return false;
                                    if (typeof value === 'object') {
                                      return Object.values(value).some(v => matchesSearch(v));
                                    }
                                    return String(value).toLowerCase().includes(searchText.toLowerCase());
                                  };
                                  return Object.values(row).some(matchesSearch);
                                });
                                
                                toolkitProps.searchProps.onSearch(searchText);
                                afterSearch(searchResult);
                                }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}>
                              <h5> Grand Total : QR {grandTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Product breakup modal       */}
          <Modal
            size="lg"
            isOpen={productModal}
            toggle={() => setProductModal(!productModal)}
          >
            <ModalHeader toggle={() => setProductModal(!productModal)}>
               <Button
                                            type="submit"
                                            className="btn btn-sm btn-secondary"
                                            onClick={handleDownloadModalData}
                                          >
                                            <i className="mdi mdi-file-export"></i> {props.t("Export CSV")}
                                          </Button>
                                          {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv1");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv1">
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <CardTitle className="text-center">
                            {" "}
                            {props.t("Product Details")}
                          </CardTitle>
                          <h5>
                            Branch : {selectedBranch?.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="product_id"
                            data={selectedRow || []}
                            columns={columnsProduct}
                            striped
                            hover
                            bootstrap4
                            condensed
                            filter={filterFactory({ afterFilter })}
                            noDataIndication={
                              isLoadingBranchDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product breakup details modal       */}
                     <Modal
                      size="xl"
                      isOpen={productDetailsModal}
                      toggle={() => setProductDetailsModal(!productDetailsModal)}
                    >
                      <ModalHeader
                        toggle={() => setProductDetailsModal(!productDetailsModal)}
                      >
                        {" "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("printDivProduct");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </ModalHeader>
                      <ModalBody>
                        <Row id="printDivProduct">
                          <Col lg={12}>
                           
                                <CardTitle className="text-center">
                                {props.t("Branchwise Balance Finished Product Report")}
                                </CardTitle>
          
                            <CardTitle className="text-center">
                              {props.t("Product Details")}
                            </CardTitle>
          
                            <CardTitle className="text-center">
                              {props.t("(Product Balance Details)")}
                            </CardTitle>
                            
                            <Card>
                              <CardBody>
                                <Row>
                                <Col lg={12}>
                                  <div className="mb-1" style={{display:"flex", justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <h5 className="mb-0">Branch: {selectedBranch?.name}</h5>
                  </div>
                  <div>
                    <h5 className="mb-0">
                      Total Qty: {formatUnitsForReport(filterModalTotalQty)}
                    </h5>
                  </div>
                  <div>
                    <h5 className="mb-0">Total: {Number(filterModalSubTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
                  </div>
                </div>  
                                    <BootstrapTable
                                      keyField="_id"
                                      data={productDetails && productDetails}
                                      columns={columnsProductDetails}
                                      striped
                                      bootstrap4
                                      hover
                                      condensed
                                      noDataIndication={
                                        isLoadingProductDetails ? (
                                          <Spinner size="md" />
                                        ) : (
                                          props.t("No data to display.")
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(
    mapStatetoProps,
    {}
  )(withNamespaces()(BranchwiseProductBalanceInventoriesReport))
);
